import getIn from '@alexaivars/get-in';
import { STATES } from './constants';

const createResourceActionMatchers = (
  baseActionsCreate,
  baseActionsMerge,
  baseActionsRemove,
  baseActionsDestroy,
) => ({
  CREATE: []
    .concat(baseActionsCreate)
    .map(action => `${action}_${STATES.SUCCESS}`),
  MERGE: []
    .concat(baseActionsMerge)
    .map(action => `${action}_${STATES.SUCCESS}`),
  REMOVE: []
    .concat(baseActionsRemove)
    .map(action => `${action}_${STATES.SUCCESS}`),
  DESTROY: [].concat(baseActionsDestroy).map(action => action),
});

// CREATE - create new list
// MERGE - returns list with old and new items
// REMOVE - remove item from list
// DESTROY - delete complete list

const selectBodyData = action =>
  getIn(
    action,
    ['payload', 'body', 'data'],
    getIn(
      action,
      ['payload', 'body'],
      getIn(action, ['payload', 'data'], getIn(action, ['payload'], [])),
    ),
  );

const createResourceDataReducer = (
  baseActionsCreate,
  baseActionsMerge,
  baseActionsRemove,
  baseActionsDestroy,
  actionPayloadSelector,
) => {
  const { CREATE, MERGE, REMOVE, DESTROY } = createResourceActionMatchers(
    baseActionsCreate,
    baseActionsMerge,
    baseActionsRemove,
    baseActionsDestroy,
  );

  const getData = actionPayloadSelector || selectBodyData;
  // TODO: what should be the diference between CREATE and MERGE
  return (state = [], action = {}) => {
    const data = getData(action);
    if (CREATE.includes(action.type)) {
      return Array.isArray(data)
        ? data.reduce((state, item) => ({ ...state, [item.id]: item }), state)
        : {
            ...state,
            [data.id]: { ...data },
          };
    } else if (MERGE.includes(action.type)) {
      return Array.isArray(data)
        ? data.reduce((state, item) => ({ ...state, [item.id]: item }), state)
        : {
            ...state,
            [data.id]: { ...data },
          };
    } else if (REMOVE.includes(action.type)) {
      const ids = Array.isArray(data) ? data.map(item => item.id) : [data.id];
      const change = { ...state };
      ids.forEach(id => {
        delete change[id];
      });
      return change;
    } else if (DESTROY.includes(action.type)) {
      return [];
    } else {
      return state;
    }
  };
};

export default createResourceDataReducer;
